import { createSlice } from "@reduxjs/toolkit";
import { storage } from "../../utils/storage.js";
import { api } from "../../services/rtk/api.js";

const initialState = {
  user: storage.getUser(),
  token: storage.getToken(),
  isAuthenticated: !!storage.getToken(),
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.error = null;
      storage.clearAll();
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Login success
      .addMatcher(api.endpoints.login.matchFulfilled, (state, { payload }) => {
        state.token = payload.token;
        state.user = payload.user;
        state.isAuthenticated = true;
        state.error = null;
        storage.setToken(payload.token);
        storage.setUser(payload.user);
      })
      // Login failure
      .addMatcher(api.endpoints.login.matchRejected, (state, { payload }) => {
        state.error = payload?.data || "Authentication failed";
      })
      // Get current user success
      .addMatcher(
        api.endpoints.getCurrentUser.matchFulfilled,
        (state, { payload }) => {
          state.user = payload;
          storage.setUser(payload);
        }
      )
      // Register success
      .addMatcher(
        api.endpoints.register.matchFulfilled,
        (state, { payload }) => {
          state.token = payload.token;
          state.user = payload.user;
          state.isAuthenticated = true;
          state.error = null;
          storage.setToken(payload.token);
          storage.setUser(payload.user);
        }
      )
      // Update profile success
      .addMatcher(
        api.endpoints.updateProfile.matchFulfilled,
        (state, { payload }) => {
          state.user = { ...state.user, ...payload };
          storage.setUser(state.user);
        }
      );
  },
});

export const { logout, clearError } = authSlice.actions;
export default authSlice.reducer;
